<div class="map-menu-item" (click)="$event.stopPropagation()">
  <div class="header header--default">
    <h3 class="p-0 border-0">Driving Directions</h3>
  </div>
  <div class="scroll-container main-container">
    <form [formGroup]="drivingForm"
          class="drive-form h-100 d-flex flex-column"
          (keydown.tab)="$event.stopPropagation()"
          (ngSubmit)="getDriveDirections()"
          novalidate>
      <fieldset class="d-flex flex-column mb-0">
        <label for="from" class="label mb-0">Drive From*</label>
        <input #from formControlName="from" placeholder="123 Main St., City, State, Zip" id="from" type="text" class="form-control" [attr.maxlength]="MAX_LENGTH" tabindex="1" required>
      </fieldset>

      <fieldset class="d-flex flex-column mb-0">
        <label for="to" class="label mb-0">Drive To*</label>
        <input #to formControlName="to" placeholder="123 Main St., City, State, Zip" id="to" type="text" class="form-control" [attr.maxlength]="MAX_LENGTH" tabindex="2" required>
      </fieldset>


      <button type="submit"
              class="btn btn-primary w-100 justify-content-center directions-btn mb-3"
              tabindex="3"
              [disabled]="drivingForm.invalid">
        Get Directions
      </button>
    </form>
  </div>
  <div *ngIf="!!errorMessage" class="direction-error">
    <span class="invalid-feedback d-block">
      <i class="far fa-exclamation-circle" aria-hidden="true"></i>{{errorMessage}}
    </span>
  </div>
</div>
